var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTouchActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.961,6.863)"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11.717 7.988c-0.584-0.567-1.289-0.85-2.116-0.85c-0.827 0-1.532 .283-2.116 .85c-0.583 .567-0.875 1.253-0.875 2.056v13.694l-2.95-0.602c-0.03-0.006-0.06-0.011-0.091-0.015c0 0-0.005 0-0.01-0.001c-0.006-0.001-0.017-0.003-0.034-0.006c-0.06-0.01-0.11-0.018-0.15-0.023c-0.083-0.01-0.165-0.015-0.244-0.015c-0.342 0-0.671 .066-0.986 .198c-0.297 .124-0.563 .299-0.795 .526l-0.989 .973c-0.43 .509-0.428 1.018 .005 1.526l5.636 5.498c.521 .556 1.174 1.105 1.958 1.646c1.65 1.139 3.243 1.704 4.777 1.695c1.808-0.011 3.248-0.304 4.32-0.878c1.28-0.685 2.029-1.579 2.518-3.052c0 0 .806-1.965 1.099-4.22c.131-1.01 .242-1.924 .332-2.744c.009-0.059 .015-0.106 .019-0.14c.01-0.086 .015-0.165 .015-0.237c0-0.592-0.17-1.134-0.51-1.625c-0.326-0.471-0.752-0.817-1.277-1.037c-2.12-1.065-4.562-2.048-6.661-3.128v-8.033c0-0.803-0.292-1.489-0.875-2.056Z",
    stroke: "#fff",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.539 .137c5.257 0 9.5 4.067 9.5 9.105c0 2.758-1.274 5.223-3.3 6.895c0 0 0-5.703 0-6.895c0-2.792-2.4-5.673-6.2-5.673c-3.8 0-6.3 3.092-6.3 5.885v6.599c-0.173-0.146-0.339-0.298-0.5-0.456c-1.675-1.641-2.7-3.88-2.7-6.355c0-5.038 4.243-9.105 9.5-9.105Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTouchActive);
export default __webpack_public_path__ + "static/media/ic_touch_active.659013fea44fe8a73dc1357abfe56b55.svg";
export { ForwardRef as ReactComponent };